import React, { ReactNode, useState } from 'react';
import { WeaveThemeContext } from './WeaveThemeContext';
import { INFO360_THEMES } from '../theme.types';
import { useThemeVariables } from '../../../../utils';
import { ThemeContextValue } from '@weave-design/theme-context';
import { weaveThemes } from '../weave.types';

//Patch for users with localStorage set with previous provider, should remove later
const localStorageParser = (key: string) => {
	const item = localStorage.getItem(key);
	return item ? item.replace(/"/g, '') : null;
};

interface WeaveThemeProviderProps {
	children: ReactNode;
}

const WeaveThemeProvider = ({ children }: WeaveThemeProviderProps) => {
	const { defaultTheme, displayThemePicker } = useThemeVariables();

	const localStorageTheme = displayThemePicker
		? localStorageParser('theme')
		: defaultTheme;

	const [theme, setWeaveTheme] = useState<INFO360_THEMES>(
		(localStorageTheme ?? defaultTheme) as INFO360_THEMES,
	);
	const [weaveThemeConsumer, setWeaveThemeConsumer] =
		useState<ThemeContextValue>(weaveThemes[theme]);

	const setTheme = (newTheme: INFO360_THEMES) => {
		setWeaveTheme(newTheme);
		setWeaveThemeConsumer(weaveThemes[newTheme]);
		localStorage.setItem('theme', newTheme);
	};
	const isWeaveTheme = displayThemePicker && theme !== INFO360_THEMES.Classic;

	return (
		<WeaveThemeContext.Provider
			value={{
				theme,
				setTheme,
				displayThemePicker,
				weaveThemeConsumer,
				setWeaveThemeConsumer,
				isWeaveTheme,
			}}>
			{children}
		</WeaveThemeContext.Provider>
	);
};

export default WeaveThemeProvider;
